import { useState, useEffect, useCallback } from 'react';


const RESIZE_CALCULATION_DELAY_MS = 150;


/**
 * A hook for getting the current window size of the browser.
 * Based on: https://gist.github.com/gragland/4e3d9b1c934a18dc76f585350f97e321#gistcomment-2797291
 * @return [width, height]
 */
export default function useWindowSize() {
  const [timeoutId, setTimeoutId] = useState();
  const [size, setSize] = useState([window && window.innerWidth, window && window.innerHeight]);

  // Updates the size when the window size changes.
  // However, we want to limit the amount of times setState is called, so we use a timeout and debounce it.
  const handleResize = useCallback(() => {
    if (timeoutId) clearTimeout(timeoutId);

    setTimeoutId(setTimeout(() => {
      setSize([window.innerWidth, window.innerHeight]);
    }, RESIZE_CALCULATION_DELAY_MS));
  }, [setTimeoutId, setSize, timeoutId]);

  useEffect(() => {
    window.addEventListener('orientationchange', handleResize);
    window.addEventListener('resize', handleResize);

    // On component unmount.
    return () => {
      window.removeEventListener('orientationchange', handleResize);
      window.removeEventListener('resize', handleResize);
    };
  }, [setSize, handleResize]);

  return size; // [width, height]
}
